import { render, staticRenderFns } from "./PlatformStocksComponent.vue?vue&type=template&id=eb9937cc&"
import script from "./PlatformStocksComponent.vue?vue&type=script&lang=js&"
export * from "./PlatformStocksComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports